module.exports = __webpack_public_path__ + "static/media/sun.512b6085.png";